import React, { useState } from 'react';
import { Modal, Popconfirm } from 'antd';
import { AiOutlineEdit, AiOutlineDelete, AiOutlineEye } from 'react-icons/ai';
import { FaBuilding, FaMapMarkerAlt, FaBriefcase } from "react-icons/fa";


export default function Oportunidade({ 
    vaga, 
    onEdit, 
    onDelete 
}){
    const [isModalVisible, setIsModalVisible] = useState(false);

    // Converter strings com pipe (|) para arrays
    const parseListFromPipe = (str) => {
        if (!str) return [];
        return str.split('|').map(item => item.trim()).filter(item => item);
    };

    const responsibilities = parseListFromPipe(vaga.responsibilities);
    const requirements = parseListFromPipe(vaga.requirements);
    const benefits = parseListFromPipe(vaga.benefits);

    return (
        <>
            <div className="bg-white border border-gray-200 shadow-sm p-5 space-y-3 rounded-lg">
                <h2 className="text-base font-medium text-gray-900 line-clamp-2">{vaga.title}</h2>
                
                <div className="flex items-center gap-2 text-gray-600 text-sm">
                    <FaBuilding className="text-gray-500 flex-shrink-0" />
                    <span className="truncate">{vaga.company}</span>
                </div>
                
                <div className="flex items-center gap-2 text-gray-600 text-sm">
                    <FaMapMarkerAlt className="text-gray-500 flex-shrink-0" />
                    <span className="truncate">{vaga.location}</span>
                </div>
                
                <div className="flex items-center gap-2 text-gray-600 text-sm">
                    <FaBriefcase className="text-gray-500 flex-shrink-0" />
                    <span className="truncate">{vaga.contract_type}</span>
                </div>

                {/* Ações */}
                <div className="flex gap-2 pt-4 border-t border-gray-200">
                    <button 
                        onClick={() => setIsModalVisible(true)}
                        className="flex-1 flex items-center justify-center gap-2 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-medium transition-colors duration-200 rounded"
                    >
                        <AiOutlineEye size={16} />
                        Ver
                    </button>
                    <button 
                        onClick={() => onEdit(vaga.uuid)}
                        className="flex-1 flex items-center justify-center gap-2 py-2 bg-green-700 hover:bg-green-800 text-white text-xs font-medium transition-colors duration-200 rounded"
                    >
                        <AiOutlineEdit size={16} />
                        Editar
                    </button>
                    <Popconfirm
                        title="Tem certeza que deseja apagar esta vaga?"
                        description="Esta ação não pode ser desfeita."
                        onConfirm={() => onDelete(vaga.uuid)}
                        okText="Sim"
                        cancelText="Não"
                        okButtonProps={{ className: 'bg-green-700' }}
                    >
                        <button 
                            className="flex-1 flex items-center justify-center gap-2 py-2 bg-red-100 hover:bg-red-200 text-red-700 text-xs font-medium transition-colors duration-200 rounded"
                        >
                            <AiOutlineDelete size={16} />
                            Apagar
                        </button>
                    </Popconfirm>
                </div>
            </div>

            <Modal
                title={vaga.title}
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={700}
            >
                <div className="space-y-6 py-4">
                    <p className="text-gray-700 text-sm leading-relaxed">{vaga.description}</p>

                    {responsibilities.length > 0 && (
                        <div className="space-y-2">
                            <h3 className="font-medium text-gray-900 text-base">Responsabilidades:</h3>
                            <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm">
                                {responsibilities.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {requirements.length > 0 && (
                        <div className="space-y-2">
                            <h3 className="font-medium text-gray-900 text-base">Requisitos:</h3>
                            <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm">
                                {requirements.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {benefits.length > 0 && (
                        <div className="space-y-2">
                            <h3 className="font-medium text-gray-900 text-base">Benefícios:</h3>
                            <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm">
                                {benefits.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </Modal>
        </>
    );
}